export const CONTRATOS_LIBERA_LICENCIAS = ['GAF-8', 'GAF-3-03'];
export const CRUD_ACTIONS = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
};

/**
 * Tipos de bien a los que aplica una condición actual (campo `aplica_a` de seleccionables).
 * Una condición sin `aplica_a` se considera de uso general.
 */
export const CONDICION_APLICA_GENERAL = 'general';
export const CONDICION_APLICA_VEHICULO = 'vehiculo';

/**
 * Condición actual que solo pueden asignar los usuarios con permiso VER_CONDICION_VENTA.
 */
export const CONDICION_PARA_VENTA = 'Para venta';
